import { MerklApi } from '@merkl/api'

export const merkl = MerklApi('https://api.merkl.xyz').v4
